import React from "react";
import { makeToolbarStyles } from "./toolbar/toolbarStyles";

const {
  barStyle: sharedBarStyle,
  iconButtonStyle,
  destructiveButtonStyle,
  labelStyle,
} = makeToolbarStyles(false);

const barStyle = {
  ...sharedBarStyle,
  flexDirection: "row",
  alignItems: "center",
  gap: 12,
  padding: "10px 12px",
  marginBottom: 0,
};

const sectionStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
};

const activeToggleStyle = {
  ...iconButtonStyle,
  background: "#00a4e4",
  color: "#fff",
  border: "1px solid #1a1a1a",
};

const CollageToolbar = ({
  mode,
  selectedId,
  onFileSelected,
  onToggleSnip,
  onBringForward,
  onSendBackward,
  onDelete,
  onExportPNG,
  onClearAll,
}) => {
  return (
    <div style={barStyle}>
      <div style={sectionStyle}>
        <button
          type="button"
          aria-label="Upload image"
          title="Upload image"
          style={iconButtonStyle}
          onClick={() => onFileSelected()}
        >
          <span className="material-icons" aria-hidden="true">
            add_photo_alternate
          </span>
        </button>
        <button
          type="button"
          aria-label="Snip tool"
          title="Snip tool"
          style={mode === "snip" ? activeToggleStyle : iconButtonStyle}
          onClick={onToggleSnip}
        >
          <span className="material-icons" aria-hidden="true">
            content_cut
          </span>
        </button>
      </div>

      {selectedId && (
        <div style={sectionStyle}>
          <span style={labelStyle}>Selected:</span>
          <button
            type="button"
            aria-label="Bring forward"
            title="Bring forward"
            style={iconButtonStyle}
            onClick={onBringForward}
          >
            <span className="material-icons" aria-hidden="true">
              arrow_upward
            </span>
          </button>
          <button
            type="button"
            aria-label="Send backward"
            title="Send backward"
            style={iconButtonStyle}
            onClick={onSendBackward}
          >
            <span className="material-icons" aria-hidden="true">
              arrow_downward
            </span>
          </button>
          <button
            type="button"
            aria-label="Delete element"
            title="Delete"
            style={{
              ...iconButtonStyle,
              color: "#b42318",
              border: "1px solid rgba(180, 35, 24, 0.45)",
            }}
            onClick={onDelete}
          >
            <span className="material-icons" aria-hidden="true">
              delete
            </span>
          </button>
        </div>
      )}

      <div style={{ ...sectionStyle, marginLeft: "auto" }}>
        <button
          type="button"
          aria-label="Export as PNG"
          title="Export PNG"
          style={iconButtonStyle}
          onClick={onExportPNG}
        >
          <span className="material-icons" aria-hidden="true">
            download
          </span>
        </button>
        <button
          type="button"
          aria-label="Clear all"
          title="Clear all"
          style={destructiveButtonStyle}
          onClick={onClearAll}
        >
          <span className="material-icons" aria-hidden="true" style={{ fontSize: 18, marginRight: 4 }}>
            delete_sweep
          </span>
          Clear all
        </button>
      </div>
    </div>
  );
};

export default CollageToolbar;
